<template>
  <permission-guard situation="site_configuration">
    <v-form>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="site.instagramLink"
            class="mb-2"
            label="instagram リンク"
            style="width: 350px"
            :rules='[urlValidation]'
            required
          />
          <v-text-field
            v-model="site.twitterLink"
            class="mb-2"
            label="twitter リンク"
            style="width: 350px"
            :rules='[urlValidation]'
            required
          />
          <v-text-field
            v-model="site.facebookLink"
            class="mb-2"
            label="facebook リンク"
            style="width: 350px"
            :rules='[urlValidation]'
            required
          />
          <v-text-field
            v-model="site.youtubeLink"
            class="mb-2"
            label="youtube リンク"
            style="width: 350px"
            :rules='[urlValidation]'
            required
          />
          <v-text-field
            v-model="site.spotifyLink"
            class="mb-2"
            label="spotify リンク"
            style="width: 350px"
            :rules='[urlValidation]'
            required
          />
          <v-text-field
            v-model="site.appleMusicLink"
            class="mb-2"
            label="apple music リンク"
            style="width: 350px"
            :rules='[urlValidation]'
            required
          />
        </v-col>
      </v-row>
    </v-form>
    <v-spacer />
    <v-btn color="green darken-1" tile dark depressed @click="updateSite">
      更新
    </v-btn>
  </permission-guard>
</template>
<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  components: {
    PermissionGuard
  },
  mixins: [formValidationUtils],
  props: {
    siteId: {
      type: Number,
      required: true
    }
  },
  data: () => {
    return {
      site: {}
    }
  },
  mounted: function () {
    axios.get(`/api/sites/${this.siteId}/edit`).then(
      ({ data }) => {
        this.site = data.data.attributes
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    updateSite () {
      const site = this.site
      const query = {
        site: {
          instagramLink: site.instagramLink,
          twitterLink: site.twitterLink,
          facebookLink: site.facebookLink,
          youtubeLink: site.youtubeLink,
          spotifyLink: site.spotifyLink,
          appleMusicLink: site.appleMusicLink
        }
      }
      axios.patch(`/api/sites/${site.id}`, query).then(
        () => {
          const payload = {
            status: 200,
            message: '変更を保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style scoped></style>
